interface Props {
  style?: React.CSSProperties;
  xFeet?: number;
  yFeet?: number;
}

export const SoftballLandingPointVis: React.FC<Props> = ({
  style,
  xFeet,
  yFeet,
}) => {
  const strokeFill = "#6B7280"; // gray-500
  const ballFill = "#3B82F6"; // blue-500

  return (
    <svg
      style={style || { width: "100%" }}
      viewBox="0 0 450 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {yFeet && xFeet && (
        <circle cx={225 + xFeet} cy={300 - yFeet} r="6.5" fill={ballFill} />
      )}

      <path
        d="M248.109 271.227L373.595 147"
        stroke={strokeFill}
        strokeWidth="2"
      />
      <line
        x1="200.299"
        y1="270.713"
        x2="74.2985"
        y2="146.713"
        stroke={strokeFill}
        strokeWidth="2"
      />
      <path
        d="M218 281.277H231V288.102L224.5 294.125L218 288.102V281.277Z"
        fill={strokeFill}
      />
      <rect
        x="200.089"
        y="270.516"
        width="11.9529"
        height="26.5629"
        stroke={strokeFill}
        strokeWidth="2"
      />
      <rect
        x="236.965"
        y="270.516"
        width="11.9529"
        height="26.5629"
        stroke={strokeFill}
        strokeWidth="2"
      />
      <path
        d="M75 148C103.971 88.5704 159.607 63.9997 224.901 64C283.052 64 346.2 89.7845 373 147.509"
        stroke={strokeFill}
        strokeWidth="3"
      />
      <path
        d="M155 227C168.513 188.795 194.464 173 224.92 173C252.044 173 281.499 189.576 294 226.684"
        stroke={strokeFill}
        strokeWidth="2"
      />
      <path
        d="M202.77 49.588L209.358 43.072V41.506L208.458 40.624H204.966L204.066 41.506V42.46H202.698V41.056L204.354 39.4H209.07L210.726 41.056V43.468L204.138 49.984V50.776H210.798V52H202.77V49.588ZM212.594 50.344V48.94H213.962V49.894L214.862 50.776H218.678L219.578 49.894V47.14L218.714 46.276H215.114V45.052H218.714L219.578 44.188V41.506L218.678 40.624H214.97L214.07 41.506V42.46H212.702V41.056L214.358 39.4H219.29L220.946 41.056V44.584L219.848 45.664L220.946 46.762V50.344L219.29 52H214.25L212.594 50.344ZM223.378 50.2V41.2L225.178 39.4H230.362L232.162 41.2V50.2L230.362 52H225.178L223.378 50.2ZM229.75 50.776L230.794 49.75V41.65L225.79 40.624H225.79L224.746 41.65V49.75L225.79 50.776H229.75ZM235.581 44.206H233.961V43.036H235.581V41.038L237.147 39.472H239.739V40.624H237.723L236.913 41.416V43.036H239.739V44.206H236.913V52H235.581V44.206ZM242.348 50.344V44.206H240.728V43.036H242.384V40.12H243.68V43.036H246.488V44.206H243.68V49.93L244.58 50.83H246.488V52H244.004L242.348 50.344Z"
        fill={strokeFill}
      />
      <path
        d="M384.65 144.588L391.238 138.072V136.506L390.338 135.624H386.846L385.946 136.506V137.46H384.578V136.056L386.234 134.4H390.95L392.606 136.056V138.468L386.018 144.984V145.776H392.678V147H384.65V144.588ZM397.121 135.804L394.295 137.262V136.002L397.229 134.4H398.489V147H397.121V135.804ZM401.286 145.2V136.2L403.086 134.4H408.27L410.07 136.2V145.2L408.27 147H403.086L401.286 145.2ZM407.658 145.776L408.702 144.75V136.65L407.658 135.624H403.698L402.654 136.65V144.75L403.698 145.776H407.658ZM413.489 139.206H411.869V138.036H413.489V136.038L415.055 134.472H417.647V135.624H415.631L414.821 136.416V138.036H417.647V139.206H414.821V147H413.489V139.206ZM420.256 145.344V139.206H418.636V138.036H420.292V135.12H421.588V138.036H424.396V139.206H421.588V144.93L422.488 145.83H424.396V147H421.912L420.256 145.344Z"
        fill={strokeFill}
      />
      <path
        d="M25.6469 144.588L32.2349 138.072V136.506L31.3349 135.624H27.8429L26.9429 136.506V137.46H25.5749V136.056L27.2309 134.4H31.9469L33.6029 136.056V138.468L27.0149 144.984V145.776H33.6749V147H25.6469V144.588ZM38.1174 135.804L35.2914 137.262V136.002L38.2254 134.4H39.4854V147H38.1174V135.804ZM42.2826 145.2V136.2L44.0826 134.4H49.2666L51.0666 136.2V145.2L49.2666 147H44.0826L42.2826 145.2ZM48.6546 145.776L49.6986 144.75V136.65L48.6546 135.624H44.6946L43.6506 136.65V144.75L44.6946 145.776H48.6546ZM54.4853 139.206H52.8653V138.036H54.4853V136.038L56.0513 134.472H58.6433V135.624H56.6273L55.8173 136.416V138.036H58.6433V139.206H55.8173V147H54.4853V139.206ZM61.2529 145.344V139.206H59.6329V138.036H61.2889V135.12H62.5849V138.036H65.3929V139.206H62.5849V144.93L63.4849 145.83H65.3929V147H62.9089L61.2529 145.344Z"
        fill={strokeFill}
      />
      <rect x="216" y="248" width="17" height="2.96475" fill={strokeFill} />
      <rect
        width="10.9356"
        height="10.9356"
        transform="matrix(0.711273 -0.702916 0.711273 0.702916 217 202.687)"
        fill={strokeFill}
      />
      <rect
        width="10.9356"
        height="10.9356"
        transform="matrix(0.711273 -0.702916 0.711273 0.702916 174 245.687)"
        fill={strokeFill}
      />
      <rect
        width="10.9356"
        height="10.9356"
        transform="matrix(0.711273 -0.702916 0.711273 0.702916 260 245.687)"
        fill={strokeFill}
      />
    </svg>
  );
};
